import React from "react";

const ComparableScoreMatrix = () => {
	return <div>ComparableScoreMatrix</div>;
};

export default ComparableScoreMatrix;
